import React from 'react';
import { STATUS_LABEL, formatGoalValue, dueDateText, deptNeon, CLOSED_WORD, goalGapText } from '@battleops/shared';
import Icon from '../Icon';
import s from './TaskGoalStrip.module.css';

// The web task panel's GOAL strip (boards B7; the phone's TaskGoalStrip): ring (value of target), the number, the pace
// word, the period, the pace bar with "should be by now"; click → the goal's drawer on the department's score page.
// The Subtask board and Edit goal sit beside it. A closed goal reads DONE / TASK REMOVED / DATE PASSED with met / missed.
const TONE = { met: '#3FD69B', ahead: '#3FD69B', under: '#3FD69B', on_pace: '#FFD23F', close: '#FFD23F', behind: '#FF7A70', over: '#FF7A70' };
const periodWord = (g) => (g.period === 'until' ? `until ${dueDateText(g.due)}` : g.period === 'month' ? 'this month' : 'this week');

export default function TaskGoalStrip({ goal: g, dept, onOpen, onEdit, onBoard, boardLabel }) {
  if (!g) return null;
  const neon = deptNeon(dept);
  const closed = g.closed;
  const word = closed ? `${CLOSED_WORD[closed.why]}${closed.why === 'removed' ? '' : closed.met ? ' · MET' : ' · MISSED'}` : STATUS_LABEL[g.status] || '';
  const tone = closed ? (closed.met ? TONE.met : 'var(--c-text-tertiary)') : TONE[g.status] || 'var(--c-text-tertiary)';
  const pct = g.target ? Math.max(0, Math.min(1, g.direction === 'down' ? (g.value == null ? 0 : g.target / Math.max(g.value, 0.0001)) : (g.value || 0) / g.target)) : 0;
  const pace = !closed && g.expected != null && g.target && g.direction !== 'down' ? Math.max(0, Math.min(1, g.expected / g.target)) : null;
  const f = (v) => formatGoalValue(v, g.unit);
  const gap = closed ? null : goalGapText(g);
  const R = 25; const C = 2 * Math.PI * R;
  return (
    <div className={s.wrap} style={{ '--n1': closed && !closed.met ? 'var(--c-text-tertiary)' : neon[1] }}>
      <button type="button" className={s.main} onClick={onOpen} title="Open the goal" aria-label={`Goal: ${g.measureLabel} ${f(g.value)} of ${f(g.target)}, ${word}, ${periodWord(g)}`}>
        <span className={s.ring}>
          <svg width="58" height="58" viewBox="0 0 58 58" aria-hidden="true">
            <circle cx="29" cy="29" r={R} fill="none" stroke="var(--c-surface-alt)" strokeWidth="6" />
            {pct > 0 ? <circle cx="29" cy="29" r={R} fill="none" stroke="var(--n1)" strokeWidth="6" strokeLinecap="round" strokeDasharray={`${C * pct} ${C}`} transform="rotate(-90 29 29)" /> : null}
          </svg>
          <b>{g.target ? Math.round(pct * 100) : '—'}</b>
        </span>
        <span className={s.text}>
          <span className={s.kick}>GOAL · {String(g.measureLabel || '').toUpperCase()} · {periodWord(g).toUpperCase()}</span>
          <span className={s.value}>{f(g.value)} <span>/ {f(g.target)}{g.direction === 'down' ? ' limit' : ''}</span></span>
          <span className={s.line}><span className={s.word} style={{ color: tone }}>{word}</span>{gap ? <span>· {gap}</span> : null}{pace != null ? <span>· should be {f(Math.round(g.expected * 10) / 10)} by now</span> : null}</span>
          <span className={s.bar}><i style={{ width: `${pct * 100}%` }} />{pace != null ? <em style={{ left: `${pace * 100}%` }} /> : null}</span>
        </span>
      </button>
      <span className={s.side}>
        {onBoard ? <button type="button" onClick={onBoard}><Icon name="columns" size={13} />{boardLabel || 'Subtask board'}</button> : null}
        {onEdit ? <button type="button" onClick={onEdit}><Icon name="edit-2" size={13} />{closed ? 'New goal' : 'Edit goal'}</button> : null}
      </span>
    </div>
  );
}
